/* ============================================================================
   CircleDrops — main-product.liquid externalized scripts (ALL TEMPLATES)
   ----------------------------------------------------------------------------
   Save this file as:  assets/cd-main-product.js
   Loaded on every product template with:
     <script src="{{ 'cd-main-product.js' | asset_url }}" defer></script>

   The upsell-only scripts (variant picker fix + accordion tightening) now live
   in a SEPARATE file: assets/cd-upsell-product.js, loaded only on the upsell
   template. This file contains everything that runs on all product pages.

   All Liquid-dependent values (section id, sticky form id, etc.) are passed in
   via the inline data bridge rendered in the section:
     window.CDProduct = window.CDProduct || { instances: [] };
     window.CDProduct.instances.push({ sectionId, productUrl, isUpsell, stickyFormId });

   Shopify does NOT render Liquid inside asset .js files — that's why the
   dynamic values are bridged in rather than inlined here.
   ========================================================================== */

(function () {
  'use strict';

  function cdFirstInstance() {
    var i = (window.CDProduct && window.CDProduct.instances) || [];
    return i.length ? i[0] : null;
  }

  /* ==========================================================================
     1) MEASUREMENT THUMBNAIL BADGE  (no Liquid)
     ========================================================================== */
  (function () {
    if (window.__pdpMeasureBadgeInstalled) return;
    window.__pdpMeasureBadgeInstalled = true;

    var RULER_SVG =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">' +
      '<g fill="none" stroke="currentColor" stroke-width="1.5">' +
      '<path stroke-linejoin="round" d="M5 9.979C5 11.095 6.79 12 9 12V9.979c0-.994 0-1.492-.397-1.795c-.398-.303-.792-.19-1.58.037C5.815 8.57 5 9.226 5 9.98Z"/>' +
      '<path d="M16 8.5c0 1.933-3.134 3.5-7 3.5s-7-1.567-7-3.5S5.134 5 9 5s7 1.567 7 3.5Z"/>' +
      '<path d="M2 9v6.667C2 17.507 5.134 19 9 19h11c.943 0 1.414 0 1.707-.293S22 17.943 22 17v-3c0-.943 0-1.414-.293-1.707S20.943 12 20 12H9"/>' +
      '<path stroke-linecap="round" stroke-linejoin="round" d="M18 19v-2m-4 2v-2m-4 2v-2m-4 1.5v-2"/>' +
      '</g>' +
      '</svg>';

    function isMeasurementBullet(bullet) {
      var img = bullet.querySelector('img');
      var src = img ? (img.getAttribute('src') || '') : '';
      var bg  = bullet.style ? (bullet.style.backgroundImage || '') : '';
      return (src + ' ' + bg).toLowerCase().indexOf('measurement') !== -1;
    }

    function applyMeasureBadge() {
      var galleries = document.querySelectorAll('#main-product .l4pr, .m6pr .l4pr');
      galleries.forEach(function (l4pr) {
        var bullets = l4pr.querySelectorAll('.swiper-pagination-bullet:not(.has-more)');
        bullets.forEach(function (bullet) {
          var has = bullet.querySelector('.pdp-measure-badge');
          var want = isMeasurementBullet(bullet);
          if (want && !has) {
            var badge = document.createElement('span');
            badge.className = 'pdp-measure-badge';
            badge.setAttribute('aria-hidden', 'true');
            badge.innerHTML = RULER_SVG;
            bullet.appendChild(badge);
          } else if (!want && has) {
            has.remove();
          }
        });
      });
    }

    var scheduled = false;
    function scheduleApply() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; applyMeasureBadge(); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleApply);
    } else {
      scheduleApply();
    }
    window.addEventListener('load', scheduleApply);

    var root = document.getElementById('main-product');
    var target = root && root.querySelector('.l4pr');
    if (target && window.MutationObserver) {
      var mo = new MutationObserver(scheduleApply);
      mo.observe(target, { childList: true, subtree: true });
    }
  })();


  /* ==========================================================================
     2) GALLERY "+N MORE" TILE  (no Liquid)
     ========================================================================== */
  (function () {
    function applyMoreTile() {
      var root = document.getElementById('main-product');
      if (!root) return;

      var wrap = root.querySelector('.l4pr .swiper-pagination-bullets');
      if (!wrap) return;

      var allBullets = wrap.querySelectorAll('.swiper-pagination-bullet');
      allBullets.forEach(function (b) {
        b.classList.remove('pdp-more-tile');
        b.removeAttribute('data-more-count');
      });
      if (!allBullets.length) return;

      var hasMoreTile = wrap.querySelector('.swiper-pagination-bullet.has-more');
      var imageBullets = wrap.querySelectorAll('.swiper-pagination-bullet:not(.has-more)');
      var extraCount = 0;

      if (hasMoreTile) {
        var text = (hasMoreTile.textContent || '').trim();
        var m = text.match(/(\d+)/);
        extraCount = m ? parseInt(m[1], 10) : Math.max(1, allBullets.length - 4);
      } else if (imageBullets.length > 4) {
        extraCount = imageBullets.length - 4;
      }

      if (extraCount > 0) {
        var fourth = imageBullets[3];
        if (fourth) {
          fourth.classList.add('pdp-more-tile');
          fourth.setAttribute('data-more-count', extraCount);
        }
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyMoreTile);
    } else {
      applyMoreTile();
    }
    window.addEventListener('load', applyMoreTile);

    var root = document.getElementById('main-product');
    var target = root && root.querySelector('.l4pr');
    if (target && window.MutationObserver) {
      var mo = new MutationObserver(function () { applyMoreTile(); });
      mo.observe(target, { childList: true, subtree: true });
    }
  })();


  /* ==========================================================================
     3) ADD-TO-CART BUTTON STATE FEEDBACK  (no Liquid)
     ========================================================================== */
  (function () {
    if (window.__pdpAtcStateInstalled) return;
    window.__pdpAtcStateInstalled = true;

    var STATE_DURATION = 3500;
    var SAFETY_TIMEOUT = 8000;
    var currentBtn = null;
    var revertTimers = new WeakMap();

    function isProductForm(form) {
      return !!(form && form.action && form.action.indexOf('/cart/add') !== -1);
    }

    function isATCButton(btn) {
      if (!btn) return false;
      var t = btn.type || btn.getAttribute('type');
      if (t !== 'submit') return false;
      if (btn.name === 'checkout') return false;
      if (btn.closest && btn.closest('.shopify-payment-button')) return false;
      if (btn.classList && btn.classList.contains('shopify-payment-button__button')) return false;
      if (btn.classList && btn.classList.contains('additional-checkout-button')) return false;
      var form = btn.form || (btn.closest && btn.closest('form'));
      return isProductForm(form);
    }

    function lockButtonWidth(btn) {
      if (!btn || !btn.dataset.atcOriginalWidth) return;
      var w = btn.dataset.atcOriginalWidth + 'px';
      btn.style.setProperty('min-width', w, 'important');
      btn.style.setProperty('max-width', w, 'important');
      btn.style.setProperty('width', w, 'important');
    }

    function setLoading(btn) {
      if (!btn) return;
      clearTimeout(revertTimers.get(btn));

      if (!btn.dataset.atcOriginalHtml) {
        btn.dataset.atcOriginalHtml = btn.innerHTML;
        btn.dataset.atcOriginalWidth = String(btn.offsetWidth);
      }

      lockButtonWidth(btn);
      btn.style.setProperty('visibility', 'visible', 'important');
      btn.style.setProperty('opacity', '1', 'important');
      btn.classList.remove('is-atc-success', 'is-atc-error');
      btn.classList.add('is-atc-loading');

      var wrapper = btn.closest('p.submit, .submit, .f8pr-buy-button');
      if (wrapper) {
        wrapper.style.setProperty('visibility', 'visible', 'important');
        wrapper.style.setProperty('opacity', '1', 'important');
      }

      if (!btn.__pdpAtcObserver && window.MutationObserver) {
        btn.__pdpAtcObserver = new MutationObserver(function () {
          if (!btn.classList.contains('is-atc-loading') &&
              !btn.classList.contains('is-atc-success')) return;
          if (btn.style.visibility !== 'visible') {
            btn.style.setProperty('visibility', 'visible', 'important');
          }
          if (btn.style.opacity !== '1') {
            btn.style.setProperty('opacity', '1', 'important');
          }
        });
        btn.__pdpAtcObserver.observe(btn, { attributes: true, attributeFilter: ['style', 'hidden'] });
      }

      setTimeout(function () {
        btn.setAttribute('disabled', 'disabled');
        var originalHtml = btn.dataset.atcOriginalHtml || btn.innerHTML;
        btn.innerHTML = '<span class="atc-spinner" aria-hidden="true"></span><span class="atc-label">' + originalHtml + '</span>';
      }, 0);

      var safety = setTimeout(function () {
        if (btn.classList.contains('is-atc-loading')) revert(btn);
      }, SAFETY_TIMEOUT);
      revertTimers.set(btn, safety);
    }

    function setSuccess(btn) {
      if (!btn) return;
      clearTimeout(revertTimers.get(btn));
      btn.classList.remove('is-atc-loading', 'is-atc-error');
      btn.classList.add('is-atc-success');
      btn.setAttribute('disabled', 'disabled');
      if (!btn.dataset.atcOriginalHtml) {
        btn.dataset.atcOriginalHtml = btn.innerHTML;
        btn.dataset.atcOriginalWidth = String(btn.offsetWidth);
      }
      lockButtonWidth(btn);
      btn.innerHTML = '<span class="atc-label">Added to cart</span>';
    }

    function setError(btn) {
      revert(btn);
    }

    function revert(btn) {
      if (!btn) return;
      clearTimeout(revertTimers.get(btn));
      if (btn.__pdpAtcObserver) {
        btn.__pdpAtcObserver.disconnect();
        delete btn.__pdpAtcObserver;
      }
      btn.classList.remove('is-atc-loading', 'is-atc-success', 'is-atc-error');
      if (btn.dataset.atcOriginalHtml) {
        btn.innerHTML = btn.dataset.atcOriginalHtml;
        delete btn.dataset.atcOriginalHtml;
      }
      delete btn.dataset.atcOriginalWidth;
      btn.style.removeProperty('min-width');
      btn.style.removeProperty('max-width');
      btn.style.removeProperty('width');
      btn.style.removeProperty('visibility');
      btn.style.removeProperty('opacity');
      var wrapper = btn.closest('p.submit, .submit, .f8pr-buy-button');
      if (wrapper) {
        wrapper.style.removeProperty('visibility');
        wrapper.style.removeProperty('opacity');
      }
      btn.removeAttribute('disabled');
      if (currentBtn === btn) currentBtn = null;
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('button[type="submit"], input[type="submit"]');
      if (!isATCButton(btn)) return;
      setLoading(btn);
      currentBtn = btn;
    }, true);

    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var urlStr = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      var isCartAdd = urlStr.indexOf('/cart/add') !== -1;
      var isCartMutation = urlStr.indexOf('/cart/change') !== -1
                        || urlStr.indexOf('/cart/update') !== -1
                        || urlStr.indexOf('/cart/clear') !== -1;
      var btnAtCall = isCartAdd ? currentBtn : null;

      var promise = originalFetch.apply(this, args);
      if (isCartAdd && btnAtCall) {
        promise.then(function (response) {
          if (response && response.ok) setSuccess(btnAtCall);
          else setError(btnAtCall);
        }).catch(function () {
          setError(btnAtCall);
        });
      } else if (isCartMutation) {
        promise.then(function () {
          setTimeout(refreshFromCartSafe, 100);
        }).catch(function () {});
      }
      return promise;
    };

    function getCurrentVariantId() {
      var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (input && input.value) return parseInt(input.value, 10);
      var select = document.querySelector('form[action*="/cart/add"] select[name="id"]');
      if (select && select.value) return parseInt(select.value, 10);
      return null;
    }

    function refreshFromCart() {
      var variantId = getCurrentVariantId();
      if (!variantId) return;

      originalFetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var inCart = (cart.items || []).some(function (item) {
            return item.variant_id === variantId;
          });
          var candidates = document.querySelectorAll('button[type="submit"], input[type="submit"]');
          candidates.forEach(function (btn) {
            if (!isATCButton(btn)) return;
            if (btn.classList.contains('is-atc-loading')) return;
            if (inCart) {
              setSuccess(btn);
            } else if (btn.classList.contains('is-atc-success')) {
              revert(btn);
            }
          });
        })
        .catch(function () { /* silent */ });
    }

    var refreshInFlight = false;
    var refreshQueued = false;
    var lastRefreshAt = 0;
    function refreshFromCartSafe() {
      var now = Date.now();
      if (refreshInFlight) { refreshQueued = true; return; }
      if (now - lastRefreshAt < 400) {
        if (refreshQueued) return;
        refreshQueued = true;
        setTimeout(function () {
          refreshQueued = false;
          refreshFromCartSafe();
        }, 400 - (now - lastRefreshAt));
        return;
      }
      refreshInFlight = true;
      lastRefreshAt = now;
      var variantId = getCurrentVariantId();
      if (!variantId) { refreshInFlight = false; return; }

      originalFetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var inCart = (cart.items || []).some(function (item) {
            return item.variant_id === variantId;
          });
          var candidates = document.querySelectorAll('button[type="submit"], input[type="submit"]');
          candidates.forEach(function (btn) {
            if (!isATCButton(btn)) return;
            if (btn.classList.contains('is-atc-loading')) return;
            if (inCart) setSuccess(btn);
            else if (btn.classList.contains('is-atc-success')) revert(btn);
          });
        })
        .catch(function () {})
        .then(function () {
          refreshInFlight = false;
          if (refreshQueued) {
            refreshQueued = false;
            setTimeout(refreshFromCartSafe, 50);
          }
        });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', refreshFromCartSafe);
    } else {
      refreshFromCartSafe();
    }

    var refreshTimer = null;
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      var isOptionRadio = t.type === 'radio' && (t.name || '').indexOf('options[') === 0;
      var isVariantSelect = (t.name === 'id' || t.name === 'variant-id');
      if (!isOptionRadio && !isVariantSelect) return;
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(refreshFromCartSafe, 200);
    });

    try {
      var OriginalXHR = window.XMLHttpRequest;
      var OriginalOpen = OriginalXHR.prototype.open;
      var OriginalSend = OriginalXHR.prototype.send;

      OriginalXHR.prototype.open = function (method, url) {
        this.__pdpAtcUrl = url || '';
        return OriginalOpen.apply(this, arguments);
      };

      OriginalXHR.prototype.send = function () {
        var xhr = this;
        var url = xhr.__pdpAtcUrl || '';
        var isCartAdd = url.indexOf('/cart/add') !== -1;
        var isCartMutation = url.indexOf('/cart/change') !== -1
                          || url.indexOf('/cart/update') !== -1
                          || url.indexOf('/cart/clear') !== -1;
        var btnAtCall = isCartAdd ? currentBtn : null;

        if (isCartAdd || isCartMutation) {
          xhr.addEventListener('loadend', function () {
            if (isCartAdd && btnAtCall) {
              if (xhr.status >= 200 && xhr.status < 300) setSuccess(btnAtCall);
              else setError(btnAtCall);
            } else if (isCartMutation) {
              setTimeout(refreshFromCartSafe, 100);
            }
          });
        }
        return OriginalSend.apply(this, arguments);
      };
    } catch (e) { /* ignore */ }

    window.addEventListener('focus', refreshFromCartSafe);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') refreshFromCartSafe();
    });
  })();


  /* ==========================================================================
     4) DISABLED-RADIO CLICK GUARD  (was: {{ section.id | json }})
     ========================================================================== */
  (function () {
    if (window.__disabledClickGuardInstalled) return;
    var cfg = cdFirstInstance();
    if (!cfg) return;
    window.__disabledClickGuardInstalled = true;

    var sectionWrapper = document.getElementById('shopify-section-' + cfg.sectionId);
    if (!sectionWrapper) return;

    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!target) return;

      var input = null;
      if (target.tagName === 'INPUT' && target.type === 'radio') {
        input = target;
      } else {
        var label = target.closest && target.closest('label[for]');
        if (label) input = document.getElementById(label.getAttribute('for'));
      }
      if (!input || input.type !== 'radio') return;
      if (!sectionWrapper.contains(input)) return;
      if ((input.name || '').indexOf('options[') !== 0) return;

      if (input.classList.contains('disabled')) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);
  })();


  /* ==========================================================================
     5) STICKY-BAR VARIANT SYNC  (was: {{ sticky_form_id }} / {{ section.id }})
     ========================================================================== */
  (function () {
    if (!window.location.pathname.includes('/products/')) {
      var stickEl = document.getElementById('stick');
      var bar     = document.getElementById('sticky-atc-bar');
      if (stickEl) stickEl.style.display = 'none';
      if (bar)     bar.classList.add('hidden');
      return;
    }

    var cfg = cdFirstInstance() || {};
    var stickyFormId = cfg.stickyFormId || '';
    var sectionId = cfg.sectionId;

    var stickyVariantInput = document.getElementById(stickyFormId + '-variant-id');
    var mainVariantInput = document.getElementById('id-' + sectionId)
      || document.querySelector('form[action="/cart/add"] input[name="id"]')
      || document.querySelector('form[action="/cart/add"] select[name="id"]');

    if (mainVariantInput && stickyVariantInput) {
      mainVariantInput.addEventListener('change', function () {
        stickyVariantInput.value = this.value;
      });
    }
  })();

})();